import { render, staticRenderFns } from "./CouponIdentification.vue?vue&type=template&id=268337f1&scoped=true&"
import script from "./CouponIdentification.vue?vue&type=script&lang=js&"
export * from "./CouponIdentification.vue?vue&type=script&lang=js&"
import style0 from "./CouponIdentification.vue?vue&type=style&index=0&id=268337f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268337f1",
  null
  
)

export default component.exports